import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  list: [],
  totalEntries: null,
};

export const createSliceWithName = (name, initialState) =>
  createSlice({
    name,
    initialState,
    reducers: {
      fetchUserList: () => {
        // action only for saga
      },
      setUserList: (state, { payload }) => {
        const { list, totalEntries } = payload;
        state.list = list;
        state.totalEntries = totalEntries;
      },
    },
  });
